import React, { useEffect } from "react";
import { graphql } from "gatsby";
import { LayoutContainer } from "../containers/layout";
import PageHeadMeta from "../components/global/page-head-meta";
import { SectionWrapper } from "../components/sections";
import { ArrowRight } from "../components/icon/arrow-left";
import { cn } from "../lib/helpers";

const REDIRECT_DELAY = 500;

export const query = graphql`
  query RedirectTemplateQuery($id: String!) {
    doc: sanityRedirect(id: { eq: $id }) {
      _type
      title
      id
      _id
      slug {
        current
      }
      url
    }
  }
`;

const RedirectTemplate = ({ data, pageContext }) => {
  const isBrowser = typeof window !== "undefined";
  const finalUrl = pageContext.url || data?.doc?.url;
  const isExternal = finalUrl.match(/https?:\/\/[^/]+/);
  const path = isExternal || pageContext.url ? finalUrl : `/${finalUrl}/`;

  useEffect(() => {
    if (isBrowser && finalUrl) {
      setTimeout(() => {
        window.location.replace(path);
      }, REDIRECT_DELAY);
    }
  }, []);

  return (
    <LayoutContainer doc={{ ...data?.doc }}>
      <PageHeadMeta
        title={data.doc?.title ? `${data.doc?.title} (redirect)` : "Redirect"}
        doc={data?.doc}
      />
      <SectionWrapper layout="centered" container="large">
        <div className="text-center my-16">
          <a
            href={path}
            className="group hover:bg-dark-2 p-16 rounded-2xl block"
          >
            <span className={isExternal ? "block" : "mr-1"}>
              Redirecting you to
            </span>
            <span
              className={cn(
                isExternal ? "text-sm" : "font-semibold",
                "text-link group-hover:text-black"
              )}
            >
              {finalUrl} {isExternal ? null : <ArrowRight />}
            </span>
          </a>
        </div>
      </SectionWrapper>
    </LayoutContainer>
  );
};

export default RedirectTemplate;
